module.exports = __webpack_public_path__ + "static/img/connect01.0be92b8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/connect01.gif
// module id = dBOH
// module chunks = 1